import React, { useEffect, useState } from "react";

import { IonButton, IonCard, IonCardContent, IonIcon } from "@ionic/react";

import "./HistoryListCard.scss";
import { arrowUndo, closeCircleOutline } from "ionicons/icons";
import _ from "lodash";
import ReactPlayer from "react-player";
import { findDOMNode } from "react-dom";
import * as screenfull from "screenfull";
import { Screenfull } from "screenfull";
import { StreamingMedia } from "@ionic-native/streaming-media";

import { utilService } from "../../../../services/utilService";
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
import { CONSTANTS } from "../../../../constants";
import moment from "moment";

interface MediaCardParams {
  mediaItem: any;
  MediaListHistoryData: any;
}
const HistoryListCard: React.FC<MediaCardParams> = (props) => {
  const [player, setPlayer]: any = useState({});
  const [isWeb, setIsWeb]: any = useState(false);
  const [playerPopUpModal, setPlayerPopUpModal]: any = useState(false);
  const [showMoreButton, setShowMoreButton] = useState(false);
  const [isMoreButtonClicked, setIsMoreButtonClicked] = useState(false);

  useEffect(() => {
    if (utilService.isWeb()) {
      setIsWeb(true);
    }
  }, []);

  useEffect(() => {
    if (!_.isEmpty(props.MediaListHistoryData.message)) {
      let length;
      utilService.getScreenSize() === "small" ? (length = 18) : (length = 30);
      props.MediaListHistoryData.message.length > length
        ? setShowMoreButton(true)
        : setShowMoreButton(false);
    }
  }, [props.MediaListHistoryData]);

  if (document.addEventListener) {
    document.addEventListener("fullscreenchange", exitHandler, false);
    document.addEventListener("mozfullscreenchange", exitHandler, false);
    document.addEventListener("MSFullscreenChange", exitHandler, false);
    document.addEventListener("webkitfullscreenchange", exitHandler, false);
  }

  function exitHandler() {
    var document: any = window.document;
    if (
      !document.webkitIsFullScreen &&
      !document.mozFullScreen &&
      !document.msFullscreenElement
    ) {
      setTimeout(() => {
        showPreview();
      }, 1000);
    }
  }

  const mapMessages = (item: any) => {
    if (!_.isEmpty(item)) {
      return item;
    } else {
      return "";
    }
  };

  const mapCreatedOn = (date: any) => {
    const utc = date;
    const createdOn = moment.utc(utc).local().format("MM-DD-YYYY, hh:mm A");
    return createdOn;
  };

  const handleMoreButtonClick = () => {
    const mediaListCard: any = document.getElementById(
      `history-card-item-wrapper${props.MediaListHistoryData.id}`
    );
    if (mediaListCard) {
      mediaListCard?.style.setProperty("height", "145px");
    }
  };

  const handleLessButtonClick = () => {
    const mediaListCard: any = document.getElementById(
      `history-card-item-wrapper${props.MediaListHistoryData.id}`
    );
    if (mediaListCard) {
      mediaListCard?.style.setProperty("height", "90px");
    }
  };

  const viewItem = (type: Number, id: Number) => {
    switch (type) {
      case CONSTANTS.MEDIA_TYPE.AUDIO:
        playAudio();
        break;
      case CONSTANTS.MEDIA_TYPE.VIDEO:
        viewVideo();
        break;
      case CONSTANTS.MEDIA_TYPE.IMAGE:
        viewImage(id);
        break;
    }
  };

  const viewImage = (id: Number) => {
    viewWebImage(id);
  };

  const viewWebImage = (id: Number) => {
    const img: any = document.getElementById(`media-${id}`);
    const viewer = new Viewer(img, {
      backdrop: true,
      button: false,
      toolbar: 0,
      hide() {
        viewer.destroy();
      },
    });
    viewer.show();
  };

  const playAudio = () => {
    if (!isWeb) {
      playNativeAudio();
    } else {
      setPlayerPopUpModal(true);
    }
  };

  const playNativeAudio = () => {
    StreamingMedia.playAudio(props.MediaListHistoryData.url);
  };

  const preview = () => {
    if (isWeb) {
      (screenfull as Screenfull).request(findDOMNode(player) as any);
    }
  };

  const showPreview = () => {
    if (player.context) {
      // player.showPreview();
    }
  };

  const historyReference = (player: any) => {
    setPlayer(player);
  };

  const viewVideo = () => {
    if (!isWeb) {
      viewNativeVideo();
    } else {
      preview();
    }
  };

  const viewNativeVideo = () => {
    StreamingMedia.playVideo(props.MediaListHistoryData.url);
  };

  return (
    <div>
      <IonCard>
        <IonCardContent
          id={`history-card-item-wrapper${props.MediaListHistoryData.id}`}
          onClick={() =>
            viewItem(
              props.MediaListHistoryData.type,
              props.MediaListHistoryData.id
            )
          }
        >
          <div className="history-list-card-wraper">
            <div className="history-list-icon">
              <IonIcon icon={arrowUndo} className="history-icon-div"></IonIcon>
            </div>

            <div className="history-details-div">
              {props.MediaListHistoryData.type ===
                CONSTANTS.MEDIA_TYPE.IMAGE && (
                <img
                  className="hide-media-image"
                  id={`media-${props.MediaListHistoryData.id}`}
                  src={props.MediaListHistoryData.url}
                  alt="media"
                />
              )}
              {props.MediaListHistoryData.type === 3 && isWeb && (
                <ReactPlayer
                  ref={historyReference}
                  url={props.MediaListHistoryData.url}
                  light={false}
                  // onClickPreview={preview}
                  controls={true}
                  width={0}
                  height={0}
                />
              )}
              <div className="history-details-name">
                {props.MediaListHistoryData.name}
              </div>
              <div
                className={`media-details-message-wrapper ${
                  isMoreButtonClicked
                    ? "media-details-message-wrapper-more"
                    : ""
                }`}
              >
                <div
                  className={`media-details-message ${
                    isMoreButtonClicked ? "media-details-message-more" : ""
                  }`}
                >
                  Message: {mapMessages(props.MediaListHistoryData.message)}{" "}
                </div>
                <div className="more-button-div">
                  <IonButton
                    className={
                      showMoreButton && !isMoreButtonClicked
                        ? "more-button"
                        : "hide-button"
                    }
                    onClick={(e: any) => {
                      e.stopPropagation();
                      handleMoreButtonClick();
                      setIsMoreButtonClicked(true);
                    }}
                  >
                    + more
                  </IonButton>
                </div>
                <div className="more-button-div">
                  <IonButton
                    className={
                      isMoreButtonClicked ? "more-button" : "hide-button"
                    }
                    onClick={(e: any) => {
                      e.stopPropagation();
                      handleLessButtonClick();
                      setIsMoreButtonClicked(false);
                    }}
                  >
                    - Less
                  </IonButton>
                </div>
              </div>
              <div className="history-details-created-on">
                {mapCreatedOn(props.MediaListHistoryData.createdOn)}
              </div>
            </div>
          </div>
        </IonCardContent>
      </IonCard>

      {props.MediaListHistoryData.type === 2 && isWeb && playerPopUpModal && (
        <div className="audio-player-div">
          <div
            className="close-icon"
            onClick={() => {
              setPlayerPopUpModal(false);
            }}
          >
            <IonIcon icon={closeCircleOutline}></IonIcon>
          </div>
          <audio autoPlay controls controlsList="nodownload">
            <source src={props.MediaListHistoryData.url} />
            Your browser does not support the audio element.
          </audio>
        </div>
      )}
    </div>
  );
};

export default HistoryListCard;
